import React from 'react';

let strings = {
  version: '4.3.1',
  loginfavorites: "Sorry, to use this feature you will need to log in.",
  nullfavorites:
    "Bummer, you don't have any favorites selected. Click on the star icons next to item names, and they'll show up on this page.",
  exclamation: "Bummer!",
  closemessage: "We are closed for ",
  nomeals: "No meals are being served today",
  problemexlamation: "We've had a problem...",
  problemmessage: <>We can't find this meal's information. <br />Usually this means we aren't ready to share this meal yet.<br />Please try checking back later.</>,
  loadingexclamation: "Loading Meal...",
  loadingmessage: "If meal doesn't load, try refreshing your browser.",
  normalhoursunavailable: "Sorry, our normal hours aren't available right now.",
  hoursdisclaimer: "Hours are subject to change without notice",
  hoursdislaimertimezone: "Hours are in Eastern Time (EST/EDT)",
  hoursdisclaimerlong: "All hours are shown in Eastern Time (EST/EDT) and are subject to change without notice.",
  hoursunavailable: "Hours are currently unavailable",
  nullAllergens: "Allergens Unavailable",
  disclaimer:
    "Menus subject to change. All nutritional information is based on the listed menu items. Any additions to ingredients or condiments will change the nutritional value. All information provided is believed to be accurate and reliable as of the date of posting. Nutritional information may vary by location due to product substitutions or product availability."
};

export default strings;